import { connect } from 'react-redux';
import { compose } from 'recompose';

import {
  getTips,
  getNoShows,
  getDiscounts,
  getTopGrossing,
  getProductsSold,
  getServicesBooked,
  getCancellationsByBarber,
  getAveragePricePerService,
} from '../metrics/selectors';
import { fetchSalesByBarber } from '../metrics/actions';

const withDataProvider = compose(
  connect(
    state => ({
      tips: getTips(state),
      shop: state.auth.shop,
      noShows: getNoShows(state),
      discounts: getDiscounts(state),
      topGrossing: getTopGrossing(state),
      productsSold: getProductsSold(state),
      servicesBooked: getServicesBooked(state),
      cancellations: getCancellationsByBarber(state),
      averagePricePerService: getAveragePricePerService(state),
    }),
    {
      fetcher: fetchSalesByBarber,
    },
  ),
);

export default withDataProvider;
